import React from 'react'

export default function DowngradeArrow(props) {
  return (
    <svg
      width={props.width ? props.width : '117'}
      height={props.height ? props.height : '75'}
      viewBox='0 0 117 75'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d)'>
        <path
          d='M14.4677 7.10095L14.9623 7.53769L48 40.5712L65.2877 23.2877C67.1802 21.3951 70.1582 21.2496 72.2177 22.8509L72.7123 23.2877L95.25 45.8212L102.038 39.0377C105.201 35.8742 110.513 37.8797 110.969 42.1534L111 42.75L110.991 64.0618L110.944 64.5215L110.812 65.1457L110.686 65.5437L110.508 65.9719L110.234 66.4837L109.882 66.9894L109.462 67.4625C109.276 67.6481 109.08 67.8171 108.875 67.9692L108.291 68.3455L107.7 68.6261L107.146 68.8118L106.529 68.9422L106.219 68.9792L105.75 69H84.75C80.2761 69 77.9385 63.826 80.6381 60.4817L81.0377 60.0377L87.8213 53.25L69 34.4287L51.7123 51.7123C49.8198 53.6048 46.8418 53.7504 44.7823 52.1491L44.2877 51.7123L7.53769 14.9623C5.48744 12.9121 5.48744 9.58794 7.53769 7.53769C9.43023 5.64515 12.4082 5.49957 14.4677 7.10095Z'
          fill={props.fill ? props.fill : '#EB5757'}
        />
      </g>
      <defs>
        <filter id='filter0_d' x='0' y='0' width='117' height='75' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
          <feOffset />
          <feGaussianBlur stdDeviation='3' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  )
}
